<template>
  <div id="myModal" class="modal" v-if="show" >
    <!-- The Close Button -->
    <span class="close" @click="close">&times;</span>
    <img src="../assets/images/icons/rotate.png" class="rotate w-10 mt-2 mr-16 cursor-pointer" @click="rotation()"/>

    <!-- Modal Content (The Image) -->
    <img class="modal-content" v-bind:style="{transform: `rotate(${deg}deg)`}" @click.stop :src="image" />

    <!-- Modal Caption (Image Text) -->
    <!-- <div id="caption"></div> -->
  </div>
</template>

<script>
export default {
  props: {
    image: {
      required: true,
      type: String,
    },
    show: {
      type: Boolean,
    },
  },
  data() {
    return {
      deg:0,
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
    rotation() {
      this.deg += 90;
    },
  },
};
</script>

<style scoped>
.modal {
  position: fixed; /* Stay in place */
  z-index: 10000000; /* Sit on top */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: hidden; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.9); /* Black w/ opacity */
  display: flex;
  justify-content: center;
  align-items: center;
}

/* Modal Content (Image) */
.modal-content {
  margin: auto;
  display: block;
  max-height: 80%;
}

/* Caption of Modal Image (Image Text) - Same Width as the Image */
#caption {
  margin: auto;
  display: block;
  width: 80%;
  max-width: 700px;
  text-align: center;
  color: #ccc;
  padding: 10px 0;
  height: 150px;
}

/* Add Animation - Zoom in the Modal */
.modal-content,
#caption {
  animation-name: zoom;
  animation-duration: 0.6s;
}

@keyframes zoom {
  from {
    transform: scale(0);
  }
  to {
    transform: scale(1);
  }
}

/* The Close Button */
.close {
  position: absolute;
  top: 15px;
  right: 35px;
  color: #f1f1f1;
  font-size: 40px;
  font-weight: bold;
  transition: 0.3s;
}
.rotate {
  position: absolute;
  top: 15px;
  right: 35px;
  font-weight: bold;
  transition: 0.3s;
  color: white;
}

.close:hover,
.close:focus {
  color: #bbb;
  text-decoration: none;
  cursor: pointer;
}

/* 100% Image Width on Smaller Screens */
@media only screen and (max-width: 700px) {
  .modal-content {
    max-height: 100%;
  }
}
</style>
